import { api } from "../../utils/api";

export async function linkParcel(data) {
  try {
    const response = await api.post(`installments-link`, data);
    return response.data;
  } catch (error) {
    // Adicionando verificação se existe uma mensagem de erro na resposta
    throw error;
  }
}
